import './feature-highlights.scss';

/**
 * version    1.0
 * class      <type> ()
 * classdesc  Component that manage the feature highlights section
 */
export class FeatureHighlights {}
